export default function externalSourcesService($http, RESOURCES) {
  var service;

  service = {
    getAllExternalSources: getAllExternalSources,
  };

  return service;

  function getAllExternalSources() {
    return $http.get(RESOURCES.SOURCES);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/externalSources.service.ts